export default __webpack_public_path__ + "static/media/courirer.2a9e40af.jpg";